import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { navigationViews, UpdateService } from '../../../services/update.service';

@Component({
	selector: 'getting-started',
	templateUrl: 'getting-started.html',
	styleUrls: ['./getting-started.scss']
})
export class GettingStartedComponent implements OnInit {

	constructor(
		private _meta: Meta,
		private _updateService: UpdateService
	) {
		this._meta.updateTag({ name: 'description',
			content: 'CropManage is a crop management web application developed ' +
			'by UCANR which help farmers manage irrigation and fertilization scheduling.'})
	}

	ngOnInit(): void {
		this._updateService.setCurrentPage(navigationViews.GETTING_STARTED);
	}
}
